/*
 * LOHR Google Reviews carousel controls.
 * Progressive enhancement ONLY: the track is a native CSS scroll-snap row that
 * scrolls/swipes without JS. This just wires the prev/next arrows + disabled state.
 * ES2017-clean (no optional chaining / nullish / private fields) — verified with acorn.
 */
(function () {
  'use strict';

  function initCarousel(root) {
    if (!root || root.getAttribute('data-gr-ready') === 'true') return;
    var track = root.querySelector('[data-gr-track]');
    var controls = root.querySelector('[data-gr-controls]');
    if (!track || !controls) return;
    var prev = controls.querySelector('[data-gr-prev]');
    var next = controls.querySelector('[data-gr-next]');
    if (!prev || !next) return;

    root.setAttribute('data-gr-ready', 'true');

    function hasOverflow() {
      return track.scrollWidth - track.clientWidth > 2;
    }

    function step() {
      // advance roughly one viewport of cards, keeping a little context
      var w = track.clientWidth * 0.9;
      if (w < 240) w = 240;
      return w;
    }

    function updateState() {
      if (!hasOverflow()) {
        controls.setAttribute('hidden', '');
        return;
      }
      controls.removeAttribute('hidden');
      var max = track.scrollWidth - track.clientWidth - 2;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max;
    }

    prev.addEventListener('click', function () {
      track.scrollBy({ left: -step(), behavior: 'smooth' });
    });
    next.addEventListener('click', function () {
      track.scrollBy({ left: step(), behavior: 'smooth' });
    });

    // keyboard parity: the focusable track scrolls with arrow/Home/End keys
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); track.scrollBy({ left: step(), behavior: 'smooth' }); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); track.scrollBy({ left: -step(), behavior: 'smooth' }); }
      else if (e.key === 'Home') { e.preventDefault(); track.scrollTo({ left: 0, behavior: 'smooth' }); }
      else if (e.key === 'End') { e.preventDefault(); track.scrollTo({ left: track.scrollWidth, behavior: 'smooth' }); }
    });

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        updateState();
        ticking = false;
      });
    }, { passive: true });

    if (window.ResizeObserver) {
      var ro = new ResizeObserver(function () { updateState(); });
      ro.observe(track);
    } else {
      window.addEventListener('resize', updateState);
    }

    updateState();
  }

  function initAll() {
    var roots = document.querySelectorAll('[data-gr-carousel]');
    for (var i = 0; i < roots.length; i++) initCarousel(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
